export * from '../micro-frontend/src/micro-frontend.def';
